module.exports = __webpack_public_path__ + "img/shipping-black.abaac6ec.svg";